import script from "./newNote.vue?vue&type=script&setup=true&lang=js"
export * from "./newNote.vue?vue&type=script&setup=true&lang=js"

import "./newNote.vue?vue&type=style&index=0&id=bfb55078&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bfb55078"]])

export default __exports__